<template>
	<ja-textarea
		v-model="answerValue"
		aria-live="off"
		:placeholder="$t('questionInputPlaceholder')"
		name="freeText"
		@input="onInput"
	></ja-textarea>
</template>
<script>
import Textarea from '@/components/ui/form/Textarea';

export default {
	components: {
		jaTextarea: Textarea
	},
	props: {
		selectedAnswer: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			answerValue: this.selectedAnswer
		};
	},
	methods: {
		onInput() {
			this.$emit('answerSelected', {
				answer: this.answerValue
			});
		}
	}
};
</script>
<style lang="scss" scoped></style>
